import React, { createContext, useContext, useState } from "react";
const AppContext = createContext();
export const AppContextProvider = ({ children }) => {
  const [reFetch, setReFetch] = useState(false)
  const [rightSideContent, setRightSideContent] = useState(null);
  const [isReadMoreVisible, setIsReadMoreVisible] = useState(false);
  const [caseInformation, setCaseInformation] = useState(null);
  const [serviceInformation, setServiceInformation] = useState(null);
  const [agreementInformation, setAgreementInformation] = useState(null)
  const [isCaseDetailVisible, setIsCaseDetailVisible] = useState(false);
  const [isAgreementDetailVisible, setIsAgreementDetailVisible] = useState(false);
  const [isServiceDetailVisible, setIsServiceDetailVisible] = useState(false);
  const [prohibitionInformation, setProhibitionInformation] = useState(null);
  const [selectedPanel, setSelectedPanel] = useState(null)
  return (
    <AppContext.Provider
      value={{
        rightSideContent,
        setRightSideContent,
        isReadMoreVisible,
        setIsReadMoreVisible,
        caseInformation,
        setCaseInformation,
        serviceInformation,
        setServiceInformation,
        agreementInformation,
        setAgreementInformation,
        isAgreementDetailVisible,
        setIsAgreementDetailVisible,
        isCaseDetailVisible,
        setIsCaseDetailVisible,
        isServiceDetailVisible,
        setIsServiceDetailVisible,
        selectedPanel,
        setSelectedPanel,
        reFetch,
        setReFetch,
        prohibitionInformation,
        setProhibitionInformation
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => {
  return useContext(AppContext);
};
